import dlv from 'dlv'
import fetch from './fetch.js'
import debounce from 'lodash.debounce'
import { isDescendant } from './utils.js'

const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
]

const ALTERNATE_CHARS = {
  u: ['û', 'ü', 'ù', 'ú', 'ū']
}

const ENDPOINTS = {
  departures: `https://${window.LBA.apiDomain}/departures`,
  arrivals: `https://${window.LBA.apiDomain}/arrivals`
}

let $inputs = document.querySelectorAll('[data-search-eager]')

if ($inputs.length) {
  Array.from($inputs).forEach(init)
}

function transformDate (val, context) {
  let now = new Date()
  let [date, time] = context.scheduled.split(' ')
  let [year, month, day] = date.split('-').map(x => parseInt(x, 10))
  return `${day} ${MONTHS[month - 1].substr(0, 3)}${
    year !== now.getFullYear() ? ` ${year}` : ''
  }, ${time
    .split(':')
    .slice(0, 2)
    .join(':')}`
}

let transform = {
  departures: {
    url (val, context) {
      return `/flights/LBA/${context.destination.iata}/${
        context.flight_number
      }/${context.scheduled.replace(' ', 'T')}`
    },
    date: transformDate
  },
  arrivals: {
    url (val, context) {
      return `/flights/${context.departure.iata}/LBA/${
        context.flight_number
      }/${context.scheduled.replace(' ', 'T')}`
    },
    date: transformDate
  },
  destinations: {
    url (val) {
      return val
    }
  },
  help: {
    url: x => x
  }
}

let filters = {
  departures: x => x.scheduled,
  arrivals: x => x.scheduled
}

function init ($input) {
  let $form = $input.closest('form')
  let $resultsContainer = $form.querySelector('.js-search-results')
  let $resultsInner = $resultsContainer.firstElementChild
  let resultTemplate = $resultsContainer.querySelector('.js-template').innerHTML
  let $spinner = $form.querySelector('.js-spinner')
  let haveResults = false
  let spinnerTimeout = null
  let selectedIndex = -1
  let $options
  let searchType = $input.getAttribute('data-search-eager')
  let preselect = $input.hasAttribute('data-preselect')
  let preventSubmit = $input.hasAttribute('data-prevent-submit')

  let results = []

  fetch(ENDPOINTS[searchType]).then(res => res.json()).then(res => {
    results = typeof res.query !== 'undefined' && res.query !== $input.value ? [] : res
  })

  window.addEventListener('click', e => {
    if (e.target && !isDescendant($form, e.target)) {
      $resultsContainer.hidden = true
    }
  })

  window.addEventListener(
    'focus',
    e => {
      if (e.target && !isDescendant($form, e.target)) {
        $resultsContainer.hidden = true
      }
    },
    true
  )

  $input.addEventListener('focus', () => {
    if (haveResults) {
      $resultsContainer.hidden = false
    }
  })

  function reset () {
    haveResults = false
    selectedIndex = -1
    $options = []
    $resultsContainer.hidden = true
    $resultsInner.innerHTML = ''
  }

  function showNoResults (value) {
    selectedIndex = -1
    $options = []
    $resultsContainer.hidden = false
    $resultsInner.innerHTML = ''
    let $noResults = document.createElement('div')
    $noResults.classList = 'py-3 sm:py-5 px-6 sm:px-8 md:px-10'
    $noResults.appendChild(
      document.createTextNode(`No results for “${value}”`)
    )
    $resultsInner.appendChild($noResults)
  }

  function showSpinner () {
    if (!$spinner) return
    if (typeof spinnerTimeout === 'number') {
      window.clearTimeout(spinnerTimeout)
    }
    spinnerTimeout = window.setTimeout(() => {
      $spinner.hidden = false
    }, 200)
  }

  function hideSpinner () {
    if (!$spinner) return
    if (typeof spinnerTimeout === 'number') {
      window.clearTimeout(spinnerTimeout)
      spinnerTimeout = null
    }
    $spinner.hidden = true
  }

  const flightUrlFormatter = (data = []) => `/flights/LBA/${ data.join('/') }`.replace(' ', '')

  const search = debounce(val => {

    if (results.length === 0) {
      hideSpinner()
      return showNoResults(val)
    }

    if (preselect) {
      selectedIndex = 0
    }

    const markup = results.map((result, i) => {
      return (
        resultTemplate.replace(/\{([a-z-_.]+)\}/g, (m, p1) => {
          if (p1 === 'selected') {
            return i === selectedIndex ? 'true' : 'false'
          }
          if (p1 === 'url') {
            return flightUrlFormatter([
              result.airport_iata,
              result.flight_ident,
              result.scheduled_time.replace(' ', 'T')
            ])
          }
          let v = dlv(result, p1, '')
          return v
            ? v.toString().replace(
              new RegExp(
                val.replace(/[a-z]/gi, m => {
                  if (ALTERNATE_CHARS[m.toLowerCase()]) {
                    return `(${m}|${ALTERNATE_CHARS[
                      m.toLowerCase()
                    ].join('|')})`
                  }
                  return m
                }),
                'ig'
                ),
                m => `<mark class="text-current bg-yellow">${m}</mark>`
              )
            : ''
        }).replace(/^\s+|\s+$/g, '')
      )
    }).filter(f => f.includes('<mark')).join('')

    if(markup.length) {
      $resultsInner.innerHTML = markup
      $resultsContainer.hidden = false
      $options = Array.from($resultsInner.children)
      select(selectedIndex)
    } else {
      hideSpinner()
      showNoResults(val)
    }

  }, 100)

  $input.addEventListener('input', e => {
    let val = e.target.value
    if (val.length < 3) {
      reset()
    } else {
      search(val)
    }
  })

  function select (index) {
    if (selectedIndex >= 0) {
      $options[selectedIndex].setAttribute('aria-selected', 'false')
    }
    selectedIndex = index
    if (index >= 0) {
      $options[selectedIndex].setAttribute('aria-selected', 'true')
      $input.setAttribute('aria-activedescendant', $options[selectedIndex].id)
    }
  }

  $resultsContainer.addEventListener('mouseover', e => {
    let $option = e.target.closest('[role="option"]')
    if ($option) {
      select($options.indexOf($option))
    }
  })

  $input.addEventListener('keydown', e => {
    if (e.which === 40) {
      // DOWN
      e.preventDefault()
      let index = selectedIndex + 1
      if (index > $options.length - 1) index = preselect ? 0 : -1
      select(index)
    } else if (e.which === 38) {
      // UP
      e.preventDefault()
      let index = selectedIndex === -1 ? $options.length - 1 : selectedIndex - 1
      if (index < 0) index = preselect ? $options.length - 1 : -1
      select(index)
    } else if (e.which === 13) {
      // RETURN
      if ($options[selectedIndex]) {
        e.preventDefault()
        window.location = $options[selectedIndex].href
      }
    }
  })

  if (preventSubmit) {
    $input.form.addEventListener('submit', e => {
      e.preventDefault()
    })
  }
}



// WEBPACK FOOTER //
// ./src/js/_search-eager.js